module.exports = __webpack_public_path__ + "static/media/disasterpets.6745b006.jpeg";